import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService, PRODUCT_NORMALIZER, UserIdService } from '@spartacus/core';
import { map, catchError, of } from 'rxjs';
import { KB_PRODUCT_URL_NORMALIZER } from 'src/app/app.module';

@Injectable({
  providedIn: 'root',
})
export class SavedShoppingCartService {
  userId: string;

  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private userIdService: UserIdService,private converterService:ConverterService
  ) {
    this.userIdService.getUserId().subscribe((uid) => (this.userId = uid));
  }

  getSavedCart(currentPage = 0, sort?) {
    return this.http.get(this.occEndpointsService.buildUrl(`mysavedcart/saved-carts?page=${currentPage}&sort=${sort}`));
  }
  getSavedCartDetails(cartId) {
    return this.http.get(this.occEndpointsService.buildUrl(`mysavedcart/savedcartdetails?cartCode=${cartId}`)).pipe(
      map((res: any) => {
        if (res.savedCartData) {          
          res.savedCartData = { ...res.savedCartData,
            savedCartData:res.savedCartData.entries.map((x)=>
              {
               x.product= this.converterService.convert(x.product,PRODUCT_NORMALIZER);
               return x;
              } )
        };
      }
        return res;
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }

  deleteSavedCartDetails(cartId) {
    return this.http.post(this.occEndpointsService.buildUrl(`mysavedcart/delete?cartId=${cartId}`), {});
  }
  restoreSavedCartDetails(cartId) {
    return this.http.post(this.occEndpointsService.buildUrl(`mysavedcart/restore?cartId=${cartId}`), {});
  }

  updateSavedCartDetails(cartId, name, desc) {
    return this.http.post(
      this.occEndpointsService.buildUrl(`mysavedcart/edit?cartCode=${cartId}&name=${name}&description=${desc}`),
      {}
    );
  }

  removeEntry(code, entryNbr) {
    return this.http.post(
      this.occEndpointsService.buildUrl(`mysavedcart/deleteEntries?cartCode=${code}&entryNumbers=${entryNbr}`),
      {}
    );
  }

  restoreCart(cartId) {
    return this.http.patch(
      this.occEndpointsService.buildUrl(`users/${this.userId}/carts/${cartId}/restoresavedcart`),
      {}
    );
  }
}
